/**
 * Shared navigation utility for CarbonSafe pages.
 * Dispatches a custom event that App.tsx listens for,
 * matching the same handleNavigate behaviour (pushState + scroll to top).
 */
export function navigate(page: string) {
  window.dispatchEvent(new CustomEvent('carbonsafe:navigate', {
    detail: {
      page
    }
  }));
}